import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { CHART_COLORS } from '../utils';

export const LegendWrapper = styled.div`
	display: flex;
	width: 100%;
	padding: 24px 0;
`;

export const LegendItem = styled.div`
	display: flex;
	align-items: center;
	padding-left: 24px;
`;

export const LegendColor = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 1px;
	background-color: ${props => props.color};

	${({ colorSplit }) =>
		colorSplit &&
		css`
			background-image: -webkit-linear-gradient(
				45deg,
				${CHART_COLORS.RED} 0%,
				${CHART_COLORS.RED} 48%,
				${colors.white} 48%,
				${colors.white} 52%,
				${CHART_COLORS.GREEN} 52%,
				${CHART_COLORS.GREEN} 100%
			);
		`};
`;

export const LegendName = styled.div`
	font-size: 11px;
	color: ${colors.grey8};
	padding-left: 8px;
`;
